import { AuthenticatedHttp, GuestHttp } from '@/http/axios';
import { AppError } from '@/utils/api';

const RECAPTCHA_ERROR_MESSAGE =
  'Detectamos um problema com sua solicitação. Por favor, tente novamente usando um dispositivo ou navegador diferente.';

const RECAPTCHA_ERROR_CODE = 'Recaptcha validation failed.';

export const login = ({ email, password, recaptchaToken }) =>
  GuestHttp.post('/token/', {
    email,
    password,
    recaptchaToken,
  })
    .then(({ data }) => {
      if (data.ephemeral_token) {
        return {
          type: '2fa',
          ephemeralToken: data.ephemeral_token,
          methods: data.methods,
        };
      }

      return {
        type: 'direct',
        accessToken: data.access,
        refreshToken: data.refresh,
      };
    })
    .catch((error) => {
      if (
        error?.response?.status === 400 &&
        error?.response?.data?.detail === RECAPTCHA_ERROR_CODE
      ) {
        throw new AppError({
          message: RECAPTCHA_ERROR_MESSAGE,
        });
      }
      throw new AppError(error);
    });

export const logout = async () => {
  await AuthenticatedHttp.post('/session-logout/')
}

export const loginSecondStepService = (ephemeral_token, code) =>
  GuestHttp.post('/token/code/', {
    ephemeral_token,
    code,
  })
    .then(({ data }) => ({
      accessToken: data.access,
      refreshToken: data.refresh,
    }))
    .catch((error) => {
      if (error?.response?.data?.detail === RECAPTCHA_ERROR_CODE) {
        throw new AppError({
          message: RECAPTCHA_ERROR_MESSAGE,
        });
      }
      throw new AppError(error);
    });

export const recoverySendCodeService = ({ email, recaptchaToken }) =>
  GuestHttp.post('/recovery/send-email/', {
    email,
    recaptchaToken,
  }).catch((error) => {
    if (error?.response?.data?.detail === RECAPTCHA_ERROR_CODE) {
      throw new AppError({
        message: RECAPTCHA_ERROR_MESSAGE,
      });
    }
    throw new AppError(error);
  });

export const recoveryChangePasswordService = ({ token, password }) =>
  GuestHttp.post('/recovery/change-password/', {
    token,
    password,
  }).catch((error) => {
    throw new AppError(error);
  });

export const register = (values) =>
  GuestHttp.post('/register/', values, { withCredentials: true })
    .then(({ data: { access } }) => ({
      accessToken: access,
    }))
    .catch((error) => {
      throw new AppError(error);
    });

export const socialLogin = ({ access_token, affiliateCode, provider = 'google' }) =>
  GuestHttp.post(`/login/${provider}/`, {
    access_token,
    affiliateCode,
  })
    .then(({ data: { access_token: internalAccessToken } }) => ({
      accessToken: internalAccessToken,
    }))
    .catch((error) => {
      throw new AppError(error);
    });

export const me = () =>
  AuthenticatedHttp.get('/user/').then(({ data: user }) => ({
    ...user,
    picture:
      user.picture || 'https://api-dev-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg',
  }));

export const getOtpToken = (token) =>
  token ? GuestHttp.post(`/login/otp/`, { token }).then(({ data }) => data) : { redirect: true };
